import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { booleanBodyRender, TableColumn } from '@app/components/common/table';
import { WarehouseType } from '@app/api/models/distributor';

export const useColumns = ({
  onEdit,
}: {
  onEdit: (item: WarehouseType) => void;
}): TableColumn[] => [
  {
    name: 'id',
    label: '#',
    options: {
      // filter: true,
      sort: false,
    },
  },
  {
    name: 'name',
    label: 'Название',
    options: {
      // filter: true,
      sort: true,
    },
  },
  {
    name: 'is_active',
    label: 'Активен',
    options: {
      // filter: {
      //   type: 'boolean',
      // },
      sort: true,
      customBodyRender: booleanBodyRender(),
    },
  },
  {
    name: 'id',
    label: 'Действия',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_, { rowData }) => (
        <Flex gap={2}>
          <IconButton
            aria-label="edit"
            onClick={() => onEdit(rowData as WarehouseType)}
          >
            <MdEdit />
          </IconButton>
        </Flex>
      ),
    },
  },
];
